export default __webpack_public_path__ + "static/media/sort.c82e171e.svg";